/**
 * EN / ES translations for the /blog index and post pages.
 * Imported and merged into the main translations object.
 */
export const blogTranslations = {
  en: {
    blog: {
      eyebrow: "Blog",
      title: "Notes on AI, automation and running a leaner business",
      subtitle:
        "Practical ideas, playbooks and lessons from the systems we build for growing businesses.",
      empty: "No posts yet. Check back soon!",
      readMore: "Read article",
      minRead: "min read",
      backToBlog: "All articles",
      newer: "Newer posts",
      older: "Older posts",
      pageLabel: "Page",
      previousPost: "Previous article",
      nextPost: "Next article",
      ctaTitle: "Want this working in your business?",
      ctaText: "Book a free 15-minute call and we'll show you where custom AI could take manual work off your team's plate.",
    },
  },
  es: {
    blog: {
      eyebrow: "Blog",
      title: "Notas sobre IA, automatización y cómo operar un negocio más eficiente",
      subtitle:
        "Ideas prácticas, guías y aprendizajes de los sistemas que construimos para negocios en crecimiento.",
      empty: "Todavía no hay artículos. ¡Vuelve pronto!",
      readMore: "Leer artículo",
      minRead: "min de lectura",
      backToBlog: "Todos los artículos",
      newer: "Artículos más recientes",
      older: "Artículos anteriores",
      pageLabel: "Página",
      previousPost: "Artículo anterior",
      nextPost: "Artículo siguiente",
      ctaTitle: "¿Quieres esto funcionando en tu negocio?",
      ctaText: "Agenda una llamada gratis de 15 minutos y te mostraremos dónde la IA a medida podría quitarle trabajo manual a tu equipo.",
    },
  },
};
